import React, {PureComponent} from 'react';
import { Button } from 'antd';
import {Price} from '../../../lib/Common';
import { isMobile, isBrowser } from 'react-device-detect';
import ProductSummaryPlanItem from './ProductSummaryPlanItem';
import _ from 'lodash';

class ProductSummaryPlan extends PureComponent{
  constructor(props) {
    super(props);

    this.state = {
      collapse: isMobile
    };

    this.expand = this.expand.bind(this);
  }

  expand(e){
    this.setState({collapse: false});
  }

  render(){
    const { item, jpy} = this.props;
    const { collapse } = this.state;

    return(
      <div>
        <h3 className="drawr-travel__title">ご希望のプランを選択してください</h3>
        <p className="desc mb-1"><span className="text-danger">*</span> 空席があればツアー予約を確定いたします。</p>

        <div className="block-reservation rounded border p-3 mb-3 h-100">
          {collapse ?
            <div>
              <ProductSummaryPlanItem
                item={item}
                plan={Object.values(item.prices)[0]}/>
              <Button className="btn btn-block btn-outline-primary btn-sm mb-3" onClick={this.expand}>その他のプランを見る</Button>
            </div>
            : Object.values(item.prices).map(plan => (
              <ProductSummaryPlanItem
                item={item}
                plan={plan}
                key={plan.id}/>
            ))
          }
        </div>
      </div>
    )
  }
};

export default ProductSummaryPlan;



// WEBPACK FOOTER //
// ./src/pages/travel/components/ProductSummaryPlan.js